export const isTestMode = import.meta.env?.MODE === "test";
export const isProdMode = import.meta.env?.MODE === "production";
// Support docs mode in both Vite and webpack/styleguidist without relying on a global `process`.
export const isDocumentationMode =
  (typeof process !== "undefined" && process?.env?.DOCS === "true") ||
  import.meta?.env?.DOCS === "true";
